import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { getSearchListSeries } from '../../services/series.service';
import {
  CONTENT_ALIAS,
  LS_ADMIN_USER_ID,
} from '../../config/const.config';
import { getLocalValue } from '../../utils/local-cache.util';

const Series = ({
  id,
  name,
  defaultValue,
  label,
  onChange,
  sx,
  error,
  disabled,
  allowAllOptions,
  showSelectCatOption,
  addDefault,
  menuProps,
  parentSx,
  labelSx,
  onUpdatedSeries,
}) => {
  const selectedValue = [];

  if (typeof defaultValue === 'object') {
    if (defaultValue) {
      defaultValue.forEach((item) => {
        selectedValue.push(item);
      });
    }
  }

  const [booksData, setBooksData] = useState([]);

  useEffect(() => {
    const adminUserId = getLocalValue(LS_ADMIN_USER_ID);

    getSearchListSeries(adminUserId)
      .then((res) => {
        setBooksData(res.data);
        onUpdatedSeries(true)
      })
      .catch(() => {
        // nothing
      });
  }, []);

  return (
    <FormControl
      fullWidth={!addDefault}
      error={error !== ''}
      sx={addDefault && parentSx}
    >
      <InputLabel id={`field-${id}-select-label`} sx={addDefault && labelSx}>
        {label}
      </InputLabel>

      
      <Select
        labelId="demo-simple-select-label"
        id={id}
        name={name}
        value={defaultValue}
        label={label}
        onChange={onChange}
        sx={sx}
        disabled={disabled}
        MenuProps={addDefault && menuProps}
      >
        {allowAllOptions && (
          <MenuItem key={`${id}-v-`} value="All">
            {`All ${CONTENT_ALIAS.SERIES_PLURAL}`}
          </MenuItem>
        )}
        {showSelectCatOption && (
          <MenuItem key={`${id}-v-`} value={null}>
            {`-- Select ${CONTENT_ALIAS.CATEGORY_SINGULAR} --`}
          </MenuItem>
        )}
        {booksData.map((k) => (
          <MenuItem
            key={`${id}-v-${k.id}`}
            value={`${k.id}`}
            sx={{ color: `${k.status === 0 ? 'grey' : ''}` }}
          >
            {`${k.title}`}
          </MenuItem>
        ))}
      </Select>

      {error !== '' && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

Series.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onUpdatedSeries: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
  disabled: PropTypes.bool,
  allowAllOptions: PropTypes.bool,
  showSelectCatOption: PropTypes.bool,
  addDefault: PropTypes.bool,
  menuProps: PropTypes.object,
  parentSx: PropTypes.object,
  labelSx: PropTypes.object,
};
Series.defaultProps = {
  sx: {},
  error: '',
  disabled: false,
  allowAllOptions: false,
  showSelectCatOption: false,
  addDefault: false,
  menuProps: {},
  parentSx: {},
  labelSx: {},
};

export default Series;
